import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { TournamentsListPage } from '../../features/tournament';
import { tournamentBeforeLoad } from '../../features/tournament/lib/tournament-route-guard.ts';
import { createPageBackgroundSx } from '../../styles/pageBackground.ts';

export const Route = createFileRoute('/tournaments/')({
  component: RouteComponent,
  beforeLoad: tournamentBeforeLoad,
});

const tournamentsPageSx = createPageBackgroundSx();

function RouteComponent() {
  return (
    <Stack sx={tournamentsPageSx}>
      <TournamentsListPage />
    </Stack>
  );
}
